import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Home, Users, MessageSquare, Calendar, ShoppingBag,
  Image, FileText
} from 'lucide-react';

const tabs = [
  { href: '/dashboard', label: 'Feed', icon: Home },
  { href: '/groups', label: 'Groups', icon: Users },
  { href: '/events', label: 'Events', icon: Calendar },
  { href: '/marketplace', label: 'Services', icon: ShoppingBag },
  { href: '/discussions', label: 'Discuss', icon: MessageSquare },
];

const BottomTabBar = () => {
  const { user, isApproved } = useAuth();
  const location = useLocation();

  if (!user || !isApproved) return null;

  // Hide on landing, login, register pages
  const hiddenPaths = ['/', '/login', '/register', '/pending-approval'];
  if (hiddenPaths.includes(location.pathname)) return null;

  const isActive = (path) => location.pathname === path;

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 border-t border-border/40 safe-area-bottom"
      data-testid="bottom-tab-bar"
    >
      <div className="flex items-center justify-around h-14 max-w-lg mx-auto px-1">
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = isActive(tab.href);
          return (
            <Link
              key={tab.href}
              to={tab.href}
              data-testid={`tab-${tab.label.toLowerCase()}`}
              className={`flex flex-col items-center justify-center flex-1 py-1.5 relative transition-all duration-200 ${
                active
                  ? 'text-primary'
                  : 'text-muted-foreground hover:text-foreground'
              }`}
            >
              <Icon className={`h-5 w-5 ${active ? 'scale-110' : ''} transition-transform`} />
              <span className={`text-[10px] mt-0.5 font-medium ${active ? 'text-primary' : ''}`}>
                {tab.label}
              </span>
              {active && (
                <div className="absolute bottom-0 w-8 h-0.5 bg-primary rounded-full" />
              )}
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomTabBar;
